import React from 'react'
import {message} from 'antd'
import {exportExhibitionReportPdf} from '../../app/util'
import {getArtistNames} from '../../api/artistNames'
import moment from 'moment'
import HttpError from '../base/HttpError'

export default (artistIds, artistEmail, role, rawDataList, selectedItems, element) => {
    if (!artistIds) {
        message.error('Need choose an artist first!').then(() => {
        })
    }

    let promiseNames = []
    artistIds.forEach((artistId)=>{
        promiseNames.push(getArtistNames(artistId))
    })

    function get_email_by_role() {
        //Todo: fix by adding check for gallery, artist, current role is admin
        if (role === 'gallery' || role === 'artist') {
            return artistEmail
        }
        return "sales@revart.co"
    }

    Promise.all(promiseNames)
        .then(async (result) => {
            const date = moment().format('MM/DD/YYYY')
            let promises = exportExhibitionReportPdf(
                get_email_by_role(),
                result.map((r)=>r.data),
                date,
                rawDataList,
                element
            )
            promises
                .then(() => {
                })
                .catch((error) => {
                    HttpError(error)
                })
        })
        .catch((error) => {
            HttpError(error)
        })
}
